export default "__VITE_ASSET__BVNyH7me__"